import { useEffect, useState } from '@wordpress/element';
import { alert } from '@componentsNew/CustomWarning/types';
import { CustomWarning } from '@componentsNew/CustomWarning';
import CardAnalise from '@componentsNew/Analises/CardAnalises';
import ListaAnalises from '../../ListaAnalises';
import Typography from '@componentsNew/Typography';
import SemDadosAnalise from '@pages/DicasOtimizacao/AnalisesTextuais/Components/SemDadosAnalise';
import { combinarArrays } from '@hooks/UtilHooks';

export default function AnaliseLegibilidade({ analise, carregando, erro,
                                              analisePassiva, carregandoPassiva, erroPassiva,
                                              analiseOrtografia, carregandoOrtografia, erroOrtografia,
                                              analiseGramatica, carregandoGramatica, erroGramatica
                                            }) {
  const [analiseLegibilidade, setAnaliseLegibilidade] = useState([]);

  useEffect(() => {
    setAnaliseLegibilidade([]); //Reinicializa a análise de legibilidade ao montar o componente
  }, []);

  useEffect(() => {
    setAnaliseLegibilidade([]);
    combinarArrays(analise, setAnaliseLegibilidade);
    combinarArrays(analisePassiva, setAnaliseLegibilidade);
    combinarArrays(analiseOrtografia, setAnaliseLegibilidade);
    combinarArrays(analiseGramatica, setAnaliseLegibilidade);
  }, [analise, analisePassiva, analiseOrtografia, analiseGramatica]);

  useEffect(() => {
    if (carregando && carregandoPassiva && carregandoOrtografia && carregandoGramatica) {
      setAnaliseLegibilidade([]) //Reinicializa a análise de legibilidade ao receber novos dados
    }
  }, [carregando, carregandoPassiva, carregandoOrtografia, carregandoGramatica])

  return (
    <CardAnalise
      nota={analiseLegibilidade?.filter(r => r.otimizado == true).length / analiseLegibilidade?.length}
      titulo="Análise de legibilidade"
      subTitulo="Critérios textuais"
    >
      <ListaAnalises
        resultadoAnalises={analise}
        carregando={carregando}
        erro={erro}
        marcacao={true}
        tipo={'legibilidade'}
        tipoLegibilidade={'legibilidade'}
      />

      <ListaAnalises
        resultadoAnalises={analisePassiva}
        carregando={carregandoPassiva}
        erro={erroPassiva}
        marcacao={true}
        tipo={'legibilidadeVozPassiva'}
        tipoLegibilidade={'legibilidade voz passiva'}
      />

      <ListaAnalises
        resultadoAnalises={analiseOrtografia}
        carregando={carregandoOrtografia}
        erro={erroOrtografia}
        marcacao={true}
        tipo={'legibilidadeOrtografia'}
        tipoLegibilidade={'legibilidade de Ortografia'}
      />

      <ListaAnalises
        resultadoAnalises={analiseGramatica}
        carregando={carregandoGramatica}
        erro={erroGramatica}
        marcacao={true}
        tipo={'legibilidadeGramatica'}
        tipoLegibilidade={'legibilidade de Gramatica'}
      />

      {(!carregando && !carregandoPassiva && !carregandoOrtografia && !carregandoGramatica) &&
        (analiseLegibilidade?.length == 0) &&
        (erro === null && erroPassiva === null && erroOrtografia === null && erroGramatica) && (
          <div className="min-h-[15.438em] items-center justify-center flex h-full">
            <SemDadosAnalise texto="Faça a análise do artigo para obter a avaliação" />
          </div>
        )}

      {(!carregando && !carregandoPassiva && !carregandoOrtografia && !carregandoGramatica) &&
        (erro !== null && erroPassiva !== null && erroOrtografia !== null && erroGramatica) && (
          <>
            <CustomWarning
              alertType={alert.warning}
              content={
                <div>
                  <Typography className="font-[0.75rem]">
                    Palavra-chave não encontrada. Insira uma e faça a realise para obter resultados
                    completos.
                  </Typography>
                </div>
              }
            />
          </>
        )}
    </CardAnalise>
  );
}
